import ResponseSubmitForm from './response-submit-form';
export default ResponseSubmitForm;
export { ResponseSubmitForm};
